import React from 'react'
import { useTranslation } from 'react-i18next'
import Typography from '@mui/material/Typography'

import ContainedButton from 'shared/components/Buttons/ContainedButton'
import { DialogActions, DialogContent } from '@mui/material'

type Props = {
   wholesaleName: string
   handleClose: () => void
}

export default function CooperationRejectedNotification({ wholesaleName, handleClose }: Props) {
   const { t } = useTranslation('NOTIFICATIONS')

   return (
      <>
         <DialogContent>
            <Typography variant="body1">{t('coopRejectedText', { wholesaleName })}</Typography>
         </DialogContent>
         <DialogActions>
            <ContainedButton variant="contained" onClick={handleClose}>
               OK
            </ContainedButton>
         </DialogActions>
      </>
   )
}
